import React from "react";
import { Navigate } from "react-router-dom";
import { notifyWarning } from "src/assets/toastService";
import { useUser } from "src/business-types/grocery/components/UserContext";

type Props = {
  permission?: string; // "order_view"
  children: React.ReactElement;
};

/* ✅ Reusable helper */
export const hasPermission = (
  permissions: Record<string, string[]> = {},
  permission?: string
): boolean => {
  if (!permission) return true;

  const [module, action] = permission.split("_");

  return permissions?.[module]?.includes(action) || false;
};

function PermissionRoute({ permission, children }: Props) {
  const { user } = useUser();

  const permissionEnabile = true;

  // ✅ Disable check globally
  if (!permissionEnabile) return children;

  // ✅ Admin bypass
  if (user?.role[0] === "Owner") return children;

  const userPermissions = (user?.permissions || {}) as Record<string, string[]>;

  // ✅ Use helper (no duplication)
  if (!hasPermission(userPermissions, permission)) {
    notifyWarning("Permission denied");
    return <Navigate to='/' replace />;
  }

  return children;
}

export default PermissionRoute;